import { createNavigatorFactory } from "@react-navigation/core";
import { isValidElement } from "react";
import { NAVIGATOR_CONFIG } from "../headless/children";
var { Group } = createNavigatorFactory({})();
var Protected = Group;
Object.assign(Protected, {
  [NAVIGATOR_CONFIG]: true
});
function isProtectedElement(child) {
  return Boolean(/* @__PURE__ */ isValidElement(child) && child.type === Group && child.props && typeof child.props === "object" && "guard" in child.props);
}
export {
  Group,
  Protected,
  isProtectedElement
};
//# sourceMappingURL=Protected.js.map
